/**
 * Normalize successful hint responses so callers can always read `hint_data`.
 *
 * Backend hint payloads are sometimes returned directly in `result` and
 * sometimes nested under `result.hint_data`.
 */
export const normalizeHintResponse = (response) => {
  if (!response || typeof response !== 'object' || !response.success) {
    return response;
  }

  if (Object.prototype.hasOwnProperty.call(response, 'hint_data')) {
    return response;
  }

  const result = response.result;
  if (result === null || typeof result === 'undefined') {
    return response;
  }

  if (typeof result === 'object' && Object.prototype.hasOwnProperty.call(result, 'hint_data')) {
    return {
      ...response,
      hint_data: result.hint_data,
    };
  }

  return {
    ...response,
    hint_data: result,
  };
};

export default normalizeHintResponse;
